const initialState = window.__MODEL__;
const scriptsTopology = window.__SCRIPTS_TOPOLOGY__;
const {
  comments,
  editorType,
  locale,
  isPartner,
  accountLogo,
  siteUrl,
  pages,
  siteHeaderHeight,
  breakpoints,
  user,
  feedbackId,
  metaSiteId,
  pMetaSiteId,
  siteId,
  siteName,
  ownerId,
  feedbackCreatorUserGuid,
  baseURL,
  error,
  experiments,
  linkKey,
  ownerName,
} = initialState;
export {
  scriptsTopology,
  comments,
  editorType,
  locale,
  isPartner,
  accountLogo,
  siteUrl,
  pages,
  siteHeaderHeight,
  breakpoints,
  feedbackId,
  metaSiteId,
  pMetaSiteId,
  siteId,
  siteName,
  user,
  ownerId,
  feedbackCreatorUserGuid,
  baseURL,
  error,
  experiments,
  linkKey,
  ownerName,
};
